<template>
    <div class="header-component hc">
        <slot></slot>
    </div>
</template>
